import React, { HTMLAttributes } from 'react';
import Flex from '@components/Flex';
import Avatar from '@components/Avatar';
import DevText from '@components/Text';
import { Button, Card, Colors } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';
import { Endpoints } from '@app/data/consts';
import RouterLink from '@app/components/RouterLink';

export interface UserSpaceListItemProps {
    userSpaceId: ID;
    imageSrc: string | null;
    title: string;
    companyName: string;
}

export type Props = UserSpaceListItemProps & HTMLAttributes<HTMLDivElement>;

const UserSpaceListItem: React.FC<Props> = ({ userSpaceId, imageSrc, title, companyName, ...props }) => {
    const navigate = useNavigate();

    const renderUserSpaceName = () => {
        return (
            <DevText className="mb-small">
                <RouterLink
                    color={Colors.WHITE}
                    to={Endpoints.CLIENT_TEAMS.replace(':clientId', userSpaceId)}
                    lineHeight={1}
                >
                    {title}
                </RouterLink>
            </DevText>
        );
    };

    const renderUserSpaceRelationInformation = () => {
        return <DevText muted>{companyName || 'Member'}</DevText>;
    };

    const renderViewTeamButton = () => {
        return (
            <Button className="ml-1" onClick={() => navigate(Endpoints.CLIENT_TEAMS.replace(':clientId', userSpaceId))}>
                View team
            </Button>
        );
    };

    return (
        <Card compact {...props}>
            <Flex direction="row" align="center" justify="space-between">
                <Flex direction="row" align="center">
                    <Avatar alt={title} src={imageSrc} className="mr-1" />
                    <div>
                        {renderUserSpaceName()}
                        {renderUserSpaceRelationInformation()}
                    </div>
                </Flex>

                {renderViewTeamButton()}
            </Flex>
        </Card>
    );
};

export default UserSpaceListItem;
